import React, { createContext, useState, useContext } from 'react';

const LanguageContext = createContext();

export const translations = {
  en: {
    // Navbar
    nav_guasha: "Gua Sha",
    nav_mask: "Mask",
    nav_oil: "Oil",
    nav_membership: "Membership",
    nav_referrals: "Referrals",
    
    // Membership Page
    loyalty_rewards: "Loyalty Rewards",
    check_your_points: "Check Your Points",
    unlock_rewards_desc: "Unlock exclusive rewards. Every $1 spent = 1 Point.",
    phone_number: "Phone Number",
    check_points_btn: "Check Points",
    checking: "Checking...",
    earn_points: "Earn Points",
    earn_points_desc: "Shop & receive points automatically.",
    redeem_rewards: "Redeem Rewards",
    redeem_rewards_desc: "Use points for discounts on your next ritual.",
    total_points: "Total Points",
    value: "Value",
    member_not_found: "Member not found",
    error_checking: "Error checking points. Please try again.",
    enter_phone: "Enter your phone number",
    
    // Additional Membership
    invalid_phone: "Please enter a valid phone number",
    no_membership_found: "No membership found with this phone number.",
    fetch_error: "Could not find membership information. Please check your phone number and try again.",
    check_balance: "Check Balance",
    get_1_point: "Get 1 point for every $1 you spend.",
    welcome_back: "Welcome Back",
    botum_member: "Botum Member",
    member_id: "Member ID",
    status: "Status",
    active: "Active",
    check_another: "Check another number",

    // Referrals Page (if needed later, but good to have structure)
    rewards: "Rewards" 
  },
  km: {
    // Navbar
    nav_guasha: "កោសខ្យល់",
    nav_mask: "ម៉ាស់",
    nav_oil: "ប្រេង",
    nav_membership: "សមាជិកភាព",
    nav_referrals: "ការណែនាំ",

    // Membership Page
    loyalty_rewards: "រង្វាន់ភក្ដីភាព",
    check_your_points: "ពិនិត្យពិន្ទុរបស់អ្នក",
    unlock_rewards_desc: "ដោះសោរង្វាន់ពិសេស។ រាល់ការចំណាយ ១ ដុល្លារ = ១ ពិន្ទុ។",
    phone_number: "លេខទូរស័ព្ទ",
    check_points_btn: "ពិនិត្យពិន្ទុ",
    checking: "កំពុងពិនិត្យ...",
    earn_points: "ទទួលបានពិន្ទុ",
    earn_points_desc: "ទិញទំនិញ និងទទួលបានពិន្ទុដោយស្វ័យប្រវត្តិ។",
    redeem_rewards: "ប្តូរយកង្វាន់",
    redeem_rewards_desc: "ប្រើពិន្ទុសម្រាប់ការបញ្ចុះតម្លៃនៅពេលក្រោយ។",
    total_points: "ពិន្ទុសរុប",
    value: "តម្លៃ",
    member_not_found: "រកមិនឃើញសមាជិក",
    error_checking: "មានបញ្ហាក្នុងការពិនិត្យពិន្ទុ។ សូមព្យាយាមម្តងទៀត។",
    enter_phone: "បញ្ចូលលេខទូរស័ព្ទរបស់អ្នក",

    // Additional Membership
    invalid_phone: "សូមបញ្ចូលលេខទូរស័ព្ទត្រឹមត្រូវ",
    no_membership_found: "រកមិនឃើញសមាជិកភាពជាមួយលេខទូរស័ព្ទនេះទេ។",
    fetch_error: "រកមិនឃើញព័ត៌មានសមាជិក។ សូមពិនិត្យមើលលេខទូរស័ព្ទរបស់អ្នក ហើយព្យាយាមម្តងទៀត។",
    check_balance: "ពិនិត្យសមតុល្យ",
    get_1_point: "ទទួលបាន ១ ពិន្ទុរាល់ការចំណាយ ១ ដុល្លារ។",
    welcome_back: "ស្វាគមន៍ការត្រឡប់មកវិញ",
    botum_member: "សមាជិក Botum",
    member_id: "លេខសម្គាល់សមាជិក",
    status: "ស្ថានភាព",
    active: "សកម្ម",
    check_another: "ពិនិត្យលេខផ្សេងទៀត",

    rewards: "រង្វាន់"
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('en');

  const t = (key) => {
    return translations[language][key] || key;
  };

  const toggleLanguage = () => {
    setLanguage((prev) => (prev === 'en' ? 'km' : 'en'));
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
